import React from 'react';
import { MessageCircle } from 'lucide-react';
import { contactInfo } from '../data/mock';

const FloatingWhatsApp = () => {
  return (
    <a
      href={contactInfo.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 sm:bottom-8 right-4 sm:right-8 z-50 flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg shadow-green-500/30 transition-all duration-300 hover:scale-110 animate-bounce"
      aria-label="Contactez-nous sur WhatsApp"
    >
      <MessageCircle className="w-7 h-7 sm:w-8 sm:h-8" />
      <span className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-xs font-bold">1</span>
    </a>
  );
};

export default FloatingWhatsApp;
